import type { GetServerSideProps } from "next";

import { SearchPage } from "@/features/search/SearchPage";

/**
 * The site's catch-all: query searches (`/search?q=chair`) and every curated landing page, served by
 * the search microservice. There is no `pages/search`, so this route takes that path too.
 *
 * The page component and its `getServerSideProps` are kept apart in
 * `features/search/SearchPage{,.server}`, and the loader is imported *inside*
 * `getServerSideProps` rather than at the top of this module: a page module is compiled for the
 * browser as well, and the loader reaches server-only code — Apollo's server client,
 * `next-i18next`'s filesystem reader. Next strips `getServerSideProps` from the client build along
 * with what only it uses.
 */

export const getServerSideProps: GetServerSideProps = async context => {
  const { getServerSideProps: loader } = await import(
    "@/features/search/SearchPage.server"
  );

  return loader(context);
};

export default SearchPage;
